import YoutubeSVG from 'assets/icons/social/youtube.svg';
import XSVG from 'assets/icons/social/x.svg';
import InstagramSVG from 'assets/icons/social/instagram.svg';
import PinterestSVG from 'assets/icons/social/pinterest.svg';
import FacebookSVG from 'assets/icons/social/facebook.svg';
import TikTokSVG from 'assets/icons/social/tiktok.svg';
import LinkedInSvg from 'assets/icons/social/linkedin.svg';
import RedNoteSVG from 'assets/icons/social/xiaohongshu.svg';
import WeiboSVG from 'assets/icons/social/weibo.svg';
import WeChatSVG from 'assets/icons/social/wechat.svg';
import styles from './global-footer.module.scss';
import classNames from 'classnames';

export const socialLinks = [
	{
		title: 'external: instagram.com/metmuseum',
		url: 'https://www.instagram.com/metmuseum/',
		icon: <InstagramSVG className={styles.socialItemIcon} />,
		siteName: 'Instagram',
	},
	{
		title: 'external: tiktok.com/@metmuseum',
		url: 'https://www.tiktok.com/@metmuseum',
		icon: <TikTokSVG className={styles.socialItemIcon} />,
		siteName: 'TikTok',
	},
	{
		title: 'external: facebook.com/metmuseum',
		url: 'https://www.facebook.com/metmuseum',
		icon: <FacebookSVG className={styles.socialItemIcon} />,
		siteName: 'Facebook',
	},
	{
		title: 'external: linkedin.com/company/the-metropolitan-museum-of-art',
		url: 'https://www.linkedin.com/company/the-metropolitan-museum-of-art',
		icon: <LinkedInSvg className={styles.socialItemIcon} />,
		siteName: 'LinkedIn',
	},
	{
		title: 'external: twitter.com/metmuseum',
		url: 'https://x.com/metmuseum',
		icon: <XSVG className={styles.socialItemIcon} />,
		siteName: 'X',
	},
	{
		title: 'external: pinterest.com/metmuseum/',
		url: 'https://pinterest.com/metmuseum/',
		icon: <PinterestSVG className={styles.socialItemIcon} />,
		siteName: 'Pinterest',
	},
	{
		title: 'external: youtube.com/user/metmuseum',
		url: 'https://www.youtube.com/user/metmuseum',
		icon: <YoutubeSVG className={styles.socialItemIcon} />,
		siteName: 'YouTube',
	},
	{
		title: 'external: xiaohongshu.com/user/profile/5f8808ce000000000101ea2b',
		url: 'https://www.xiaohongshu.com/user/profile/5f8808ce000000000101ea2b?xsectoken=AB44iFKdEJi5ehpIVBgA6l5p3FfWYpKAYaoc-W1IqZOj4%3D&xsecsource=pc_user',
		icon: <RedNoteSVG className={styles.socialItemIcon} />,
		siteName: 'RedNote',
	},
	{
		title: 'external: weibo.com/u/3921693016',
		url: 'https://weibo.com/u/3921693016',
		icon: <WeiboSVG className={styles.socialItemIcon} />,
		siteName: 'Weibo',
	},
	{
		title: 'external: weixin.qq.com/r/mp/rztpcffELapSrbMS9269',
		url: 'https://weixin.qq.com/r/mp/rztpcffELapSrbMS9269',
		icon: <WeChatSVG className={styles.socialItemIcon} />,
		siteName: 'WeChat',
		hasQrCode: true,
		qrContentText: (
			<p
				className={classNames(
					styles.tooltipContent,
					styles.wechatTooltipContent,
				)}
			>
				<strong>大都会艺术博物馆 The Met</strong>
				<br />
				微信扫描二维码，关注我的帐号
			</p>
		),
	},
];
